import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);
    fetch("https://readdy.ai/api/form/d8p936arg7s998hi5clg", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
    })
      .then(() => {
        setSubmitted(true);
        setEmail("");
      })
      .catch(() => setSubmitted(true));
  };

  return (
    <footer className="bg-foreground-900 rounded-t-[40px] pt-16 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="text-background-50 font-heading text-xl font-semibold">
                CSSBuy<br />Spreadsheet
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed mt-4">
              Seu guia completo para dominar o CSSBuy Spreadsheet. Economize, organize e compare os melhores agentes de compras da China.
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-heading text-base font-semibold mb-4">Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-foreground-300 text-sm hover:text-background-50 transition-colors cursor-pointer">Home</Link></li>
              <li><Link to="/artigo/o-que-e-cssbuy-spreadsheet" className="text-foreground-300 text-sm hover:text-background-50 transition-colors cursor-pointer">Artigos</Link></li>
              <li><a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-foreground-300 text-sm hover:text-background-50 transition-colors cursor-pointer">kasPreadsheet</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading text-base font-semibold mb-4">Recursos</h4>
            <ul className="space-y-2.5">
              <li><span className="text-foreground-300 text-sm">Guia para Iniciantes</span></li>
              <li><span className="text-foreground-300 text-sm">Comparação de Agentes</span></li>
              <li><span className="text-foreground-300 text-sm">Dicas de Economia</span></li>
              <li><span className="text-foreground-300 text-sm">Segurança nas Compras</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-heading text-base font-semibold mb-4">Newsletter</h4>
            <p className="text-foreground-300 text-sm mb-3">
              Receba dicas e atualizações sobre CSSBuy Spreadsheet.
            </p>
            {submitted ? (
              <p className="text-accent-400 text-sm font-medium">
                Inscrição confirmada! Obrigado.
              </p>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  required
                  className="flex-1 px-4 py-2.5 rounded-full bg-foreground-800 text-background-50 text-sm placeholder:text-foreground-400 border border-foreground-700 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <button
                  type="submit"
                  className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer flex-shrink-0"
                >
                  <i className="ri-arrow-right-line text-sm"></i>
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} CSSBuy Spreadsheet. Todos os direitos reservados.
          </p>
          <p className="text-foreground-500 text-xs">
            Este site &eacute; independente. N&atilde;o somos afiliados ao CSSBuy.
          </p>
        </div>
      </div>
    </footer>
  );
}